<template>
  <div class="pagebar" v-if="records > resultsPerPage">
    <button v-if="modelValue > 2" @click="setPage(0)" title="Naar eerste pagina">
      <awesomeIcon icon="angle-double-left" />
    </button>
    <button v-if="modelValue > 1" @click="setPage(modelValue - 2)">{{ modelValue - 1 }}</button>
    <button v-if="modelValue > 0" @click="setPage(modelValue - 1)">{{ modelValue }}</button>
    <button
      class="active-page"
    >
      {{ modelValue + 1 }}
    </button>
    <button
      v-if="(modelValue + 1) < Math.ceil(records / resultsPerPage)"
      @click="setPage(modelValue + 1)"
    >
      {{ modelValue + 2 }}
    </button>
    <button
      v-if="(modelValue + 2) < Math.ceil(records / resultsPerPage)"
      @click="setPage(modelValue + 2)"
    >
      {{ modelValue + 3 }}
    </button>
    <button
      v-if="
        Math.ceil(records / resultsPerPage) > 1
        && modelValue < Math.ceil(records / resultsPerPage) - 3
      "
      @click="setPage(Math.ceil(records / resultsPerPage) - 1)"
      title="Naar laatste pagina"
    >
      <awesomeIcon icon="angle-double-right" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'pageBar',
  props: {
    records: {
      type: Number,
      default: 0,
    },
    modelValue: {
      type: Number,
      default: 0,
    },
    resultsPerPage: {
      type: Number,
      default: 20,
    },
  },
  emits: ['update:model-value'],
  methods: {
    setPage(p) {
      this.$emit('update:model-value', p);
    },
  },
};
</script>

<style lang="scss">
.pagebar {
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 12px;
  button {
    width: auto;
    min-width: 35px;
    text-align: center;
    padding: 12px 5px;
    height: 40px;
    background-color: transparent;
    color: $color-highlight;
    outline: none;
    .fa-icon {
      padding-bottom: 1px;
    }
    &:hover {
      background-color: transparent;
      color: #000;
    }
    &.active-page {
      font-weight: 600;
      color: #000;
    }
  }
}
</style>
